import { useNavigate } from "react-router-dom";
import Button from "../../components/ui/button";


export default function Error403() {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col justify-center items-center h-screen bg-white">

      <div className="text-center mb-10 flex flex-col gap-3">
        <p className="text-[24px] font-bold text-gray-90">
          접근 권한이 없습니다.
        </p>
        <p className="text-[14px] text-gray-60">
          해당 페이지에 접근할 수 없습니다.
        </p>
      </div>

      <Button
        className="w-[240px] text-[14px] font-normal"
        variant={"black"}
        label="우리 지점 시세표 보기"
        onClick={() => navigate("/quotation")}
      />
    </div>
  );
}